import { Injectable } from '@angular/core';
import { TenantRealm } from '@core/utils';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { SuccessListResponse } from '@store/_common/models/common.types';
import { ITenant } from '@core/models/tenant.model';

@Injectable({
  providedIn: 'root',
})
export class TenantConfigService {
  private configuration: TenantRealm = {
    realmName: '',
    idpUrl: '',
    idpClientId: '',
    appBaseUrl: '',
    unauthorizedUserRedirectUrl: '',
    mocks: false,
    production: true,
    logFrontErrors: false,
  };

  get appBaseUrl(): string {
    return this.configuration?.appBaseUrl;
  }

  get unauthorizedUserRedirectUrl(): string {
    return this.configuration?.unauthorizedUserRedirectUrl;
  }

  get mocks(): boolean {
    return this.configuration?.mocks;
  }

  get logFrontErrors(): boolean {
    return this.configuration?.logFrontErrors;
  }

  constructor(
    private readonly _http: HttpClient
  ) {}

  setConfiguration(config: TenantRealm): void {
    this.configuration = config;
  }

  getTenantList(): Observable<ITenant[]> {
    return this._http.get<SuccessListResponse<ITenant[]>>(`/api/core/platform/Tenants`).pipe(
      map(({ records }) => records),
      catchError(() => of([])),
      shareReplay(1)
    );
  }

  getTenant(tenantName: string): Observable<ITenant | null> {
    return this.getTenantList().pipe(
      map((list) => list.find(({ name }) => tenantName === name))
    );
  }
}
